<template>
  <div class="text-static-default-hi body-2-bold mb-32">
    <RevDivider class="mb-12 mt-20 md:mb-16" />
    <div class="mb-12 flex flex-col gap-12 md:mb-8 md:flex-row md:gap-8">
      <ItemShipping
        :class="[{ 'md:w-1/2': shouldDisplayCarriers }]"
        :shipping="shipping"
      />
      <ItemCarriers :carriers="carriers" class="md:w-1/2" />
    </div>
    <div class="flex flex-col gap-12 md:flex-row md:gap-8">
      <ItemReassurance class="md:w-1/2" :warranty-delay="warrantyDelay" />
      <ItemVerifiedRefurbished
        class="md:w-1/2"
        :product-category="productCategory"
      />
    </div>
    <RevDivider class="mt-12 md:mt-16" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { productAPI } from '@backmarket/http-api'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevDivider } from '@ds/components/Divider'

import ItemCarriers from './components/ItemCarriers/ItemCarriers.vue'
import ItemReassurance from './components/ItemReassurance/ItemReassurance.vue'
import ItemShipping from './components/ItemShipping/ItemShipping.vue'
import ItemVerifiedRefurbished from './components/ItemVerifiedRefurbished/ItemVerifiedRefurbished.vue'

const props = defineProps<{
  carriers: productAPI.GetProductResponse['compatibleCarriers']
  shipping: productAPI.GetBestOffersResponse[number]['reassurance']['shipping']
  warrantyDelay: string
  productCategory: number
}>()

const shouldDisplayCarriers = computed(() => {
  return !isEmpty(props.carriers)
})
</script>
